<div class="row">
  <div class="col text-right">
    <div>
      <span kendoTooltip position="left" [tooltipTemplate]="kInformationTemplatebp3" title="kInformationTemplatebp3" class="k-icon k-i-information k-i-info build_and_buy"></span>
    </div>
  </div>
</div>

<div *ngIf="productModel.v6SummaryMessage.length>0" style="padding:10px;background-color:lightblue;border-radius:5px;">
  <div *ngFor="let msg of productModel.v6SummaryMessage">
    {{msg.value}} <br />
  </div>
</div>
<kendo-tabstrip>
  <kendo-tabstrip-tab [title]="'General'" [selected]="true">
    <ng-template kendoTabContent>
      <div class="product-config-container-row">
        <div class="product-config-container-col">
          <div class="form-group attr-width">
            <div class="form-group attr-width">
              <label for="productReference " style="font-weight:bold">Product Reference</label><br />
              <label>{{productModel.reference}}</label>
            </div>
            <div class="form-group attr-width">
              <label for="productQuantity" style="font-weight:bold">Quantity</label><br />
              <label>{{productModel.quantity}}</label>

            </div>
            <div *ngFor="let attrs of productModel.productAttributes;let attrIndex=index">
              <app-readonly-attr-template [attrs]="attrs"></app-readonly-attr-template>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </kendo-tabstrip-tab>
  <kendo-tabstrip-tab *ngIf="productModel?.resourceFrame?.frameName?.length>0" title="{{productModel.resourceFrame.frameName}}">
    <ng-template kendoTabContent>
      <div class="product-config-container-col" *ngFor="let attrC of productModel.resourceFrame.attributeFiltersForUI;let attrCIndex=index">
        <div class="product-config-container-row" *ngFor="let attrs of attrC;let attrIndex=index">
          <app-readonly-attr-template [attrs]="attrs"></app-readonly-attr-template>
        </div>
      </div>
    </ng-template>
  </kendo-tabstrip-tab>
  <ng-container *ngIf="3===3">
    <kendo-tabstrip-tab *ngFor="let nestFrame of productModel.nestedFrames;let i=index;"
                        title="{{nestFrame.frameName}}">
      <ng-template kendoTabContent>
        <div class="product-config-container-col" *ngFor="let attrC of nestFrame.attributeFiltersForUI;let attrCIndex=index">
          <ng-container *ngFor="let attrs of attrC;let attrIndex=index">
            <div *ngIf="attrs.show" class="product-config-container-row">
              <app-readonly-attr-template [attrs]="attrs"></app-readonly-attr-template>
            </div>
          </ng-container>
        </div>
      </ng-template>
    </kendo-tabstrip-tab>
  </ng-container>
  <kendo-tabstrip-tab *ngIf="productModel?.fills?.length>0"
                      title="Fills">
    <ng-template kendoTabContent>
      <div class="product-config-container-col" *ngFor="let fill of productModel.fills;let fillIndex=index">
        <!--<ng-container *ngFor="let attrs of attrC;let attrIndex=index">-->
        <div class="product-config-container-row">
          <label style="font-weight:bold">Quantity</label><br />
        </div>
        <div class="product-config-container-row">
          <label>{{fill.quantity}}</label>
        </div>
        <div class="product-config-container-row">
          <label style="font-weight:bold">Height</label><br />
        </div>
        <div class="product-config-container-row">
          <label>{{fill.height}}</label>
        </div>
        <div class="product-config-container-row">
          <label style="font-weight:bold">Width</label><br />
        </div>
        <div class="product-config-container-row">
          <label>{{fill.width}}</label>
        </div>
        <div class="product-config-container-row">
          <label style="font-weight:bold">Thickness</label><br />
        </div>
        <div class="product-config-container-row">
          <label>{{fill.thickness}}</label>
        </div>
        <!--</ng-container>-->
      </div>
    </ng-template>

  </kendo-tabstrip-tab>
</kendo-tabstrip>
<div class="text-center">
  <button class="m-3 clearKendoButton btn btn-success"
          (click)="goBack()"
          kendoButton>
    Back
  </button>
  <button type="submit" (click)="addConfiguredItemToCart()" kendoButton
          class="m-3 clearKendoButton btn k-button" *ngIf="addToCartVisible" [disabled]="addItemInProgress">
    Add Item to Cart <kendo-loader *ngIf="addItemInProgress" style="color:blue"></kendo-loader>
  </button>
  <button type="submit" (click)="addConfiguredItemToQuote()" kendoButton
          class="m-3 clearKendoButton btn k-button" *ngIf="addToQuoteVisible" [disabled]="addItemInProgress">
    Add Item to Quote <kendo-loader *ngIf="addItemInProgress" style="color:blue"></kendo-loader>
  </button>
  <button kendoButton icon="file-pdf"
          class="m-3 clearKendoButton btn k-button" (click)="generatePDF()">
    Print
    <!--<kendo-loader ></kendo-loader> angular13-->
  </button>
  <!--[disabled]="loadingPDF"-->
</div>
<app-add-item-to-quote *ngIf="rowItemQuote?.isOpened" (addToQuoteCompleteEvent)="receiveData($event)" [inputQuoteData]="rowItemQuote"></app-add-item-to-quote>
<section>
  <ng-template #kInformationTemplatebp3 let-kInformationTemplateAnchorbp3>
    <div lass="text-white-50 bg-dark">
      <ol>
        <li>Select each tab to review your build</li>
        <li>Choose ‘Back’ to make changes</li>
        <li>Choose ‘Add to Cart’ to add item to your shopping cart</li>
        <li>Choose ‘Add to Quote’ to add item to a new or existing KawneerDirect quote</li>       
      </ol>
    </div>
  </ng-template>
</section>
